export const css = {
    root: '_26Kq_QrE',
    trigger: '_2s_JaUmy',
    value: 'g3lARHXP',
    placeholder: '_2GUfDc-Y',
    arrow: '_2x1Fvzk2',
    menuWrapper: '_1KWJFjWl',
    disabled: 'jq5IAKYi',
    readonly: '_3W31jd2h',
    invalid: '_1ptBmYtE',
    valid: '_3AknnKI_',
    ' _key': 'apic-theme/dojo/select'
};
export default css;
